export default {
  ENV: 'prod' // dev or prod or test
}
